import * as React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const A = styled.a`
  color: #00f;
  text-decoration: none;
`;

const RouterLink = styled(Link)`
  text-decoration: underline;
`;

export default function HoverLink({ children, href, to, target }) {
  if (href) {
    return (
      <A href={href} target={target}>
        {children}
      </A>
    );
  }
  if (to) {
    return <RouterLink to={to}>{children}</RouterLink>;
  }
}

const requiredPropsCheck = (props, propName, componentName) => {
  if ((!props.href && !props.to) || (props.href && props.to)) {
    return new Error(`One of 'href' or 'to' is required by '${componentName}' component.`);
  }
};
